import React from "react";

const Header = () => {
  const [istoggle, setIsToggled] = React.useState(false);
  const handleToggle = () => {
    setIsToggled((prevState) => !prevState);
  };
  const [isdisplay, setIsDisplay] = React.useState(false);
  const handledisplay = () => {
    setIsDisplay((prevState) => !prevState);
  };
  return (
    <>
      <div
        data-elementor-type="cmsmasters_header"
        data-elementor-id="163"
        className="elementor elementor-163 cmsmasters-location-cmsmasters_header cmsmasters-header-position-absolute-"
      >
        {" "}
        <div className="elementor-inner">
          <div className="elementor-section-wrap">
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-b219929 elementor-hidden-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
              data-id="b219929"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-no">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-93714dc"
                  data-id="93714dc"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <section
                      className="elementor-section elementor-inner-section elementor-element elementor-element-f6106d3 elementor-section-height-min-height elementor-section-content-middle elementor-section-boxed elementor-section-height-default cmsmasters-block-default"
                      data-id="f6106d3"
                      data-element_type="section"
                    >
                      <div className="elementor-container elementor-column-gap-no">
                        <div
                          className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-ad607a2"
                          data-id="ad607a2"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div
                              className="elementor-element elementor-element-75424be8 elementor-widget__width-initial cmsmasters-color-variation-default cmsmasters-pointer-none cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-title cmsmasters-widget-title"
                              data-id="75424be8"
                              data-element_type="widget"
                              data-widget_type="cmsmasters-title.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="cmsmasters-widget-title__heading">
                                  <a href="/" className=""></a>
                                </div>{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-2428d576 elementor-widget__width-initial cmsmasters-color-variation-default cmsmasters-pointer-none cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-title cmsmasters-widget-title"
                              data-id="2428d576"
                              data-element_type="widget"
                              data-widget_type="cmsmasters-title.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="cmsmasters-widget-title__heading">
                                  <a href="" className=""></a>
                                </div>{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-3e79f958 elementor-widget__width-initial cmsmasters-color-variation-default cmsmasters-pointer-none cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-title cmsmasters-widget-title"
                              data-id="3e79f958"
                              data-element_type="widget"
                              data-widget_type="cmsmasters-title.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="cmsmasters-widget-title__heading">
                                  <a href="" className=""></a>
                                </div>{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-f4aab35"
                          data-id="f4aab35"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div
                              className="elementor-element elementor-element-56dc8d8 cmsmasters-button-align-right cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                              data-id="56dc8d8"
                              data-element_type="widget"
                              data-widget_type="cmsmasters-button.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="elementor-widget-cmsmasters-button__button-container">
                                  <div className="elementor-widget-cmsmasters-button__button-container-inner">
                                    <a
                                      href="/contacts/"
                                      className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                      role="button"
                                     
                                    >
                                      <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-left">
                                        <span className="elementor-widget-cmsmasters-button__icon">
                                          {/* <i
                                            aria-hidden="true"
                                            className="cmsmsdemo-icon- cmsms-demo-icon-card"
                                          ></i> */}
                                        </span>
                                        <span className="elementor-widget-cmsmasters-button__text">
                                          Contact us:+968-22850704
                                        </span>
                                      </span>
                                    </a>
                                  </div>
                                </div>{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-7590763e elementor-section-content-middle elementor-section-height-min-height elementor-section-boxed elementor-section-height-default elementor-section-items-middle cmsmasters-block-default"
              data-id="7590763e"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-wide">
                <div
                  className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1939c356"
                  data-id="1939c356"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-50a7d591 elementor-widget__width-initial cmsmasters-logo-type-image cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-site-logo"
                      data-id="50a7d591"
                      data-element_type="widget"
                      data-widget_type="cmsmasters-site-logo.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-widget-cmsmasters-site-logo__container">
                          <div className="elementor-widget-cmsmasters-site-logo__image-container">
                            <a
                              href="/"
                              className="elementor-widget-cmsmasters-site-logo__link"
                              rel="nofollow"
                            >
                              <img
                                src="/imges/burooj/logo.png"
                                width={"150"}
                                height={"20"}
                                alt="Classic"
                                title="burooj"
                                className="cmsmasters-lazyload-disabled elementor-widget-cmsmasters-site-logo__img elementor-widget-cmsmasters-site-logo-main"
                              />
                            </a>
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-632bf7d7 elementor-widget__width-initial elementor-hidden-tablet elementor-hidden-mobile cmsmasters-icon-position-right cmsmasters-dropdown-breakpoints-tablet cmsmasters-toggle-view-stacked cmsmasters-dropdown-icon-right cmsmasters-pointer-none cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-nav-menu"
                      data-id="632bf7d7"
                      data-element_type="widget"
                      data-settings='{"layout":"horizontal","dropdown_breakpoints":"tablet","dropdown_horizontal_distance":{"unit":"px","size":"","sizes":[]}}'
                      data-widget_type="cmsmasters-nav-menu.default"
                    >
                      <div className="elementor-widget-container">
                        <nav className="elementor-widget-cmsmasters-nav-menu__main elementor-widget-cmsmasters-nav-menu__container cmsmasters-layout-horizontal">
                          <ul
                            id="menu-1-632bf7d7"
                            className="elementor-widget-cmsmasters-nav-menu__container-inner"
                          >
                            <li
                              id="menu-item-9259"
                              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-7626 current_page_item menu-item-9259"
                            >
                              <a
                                href="/"
                                aria-current="page"
                                className="elementor-widget-cmsmasters-nav-menu__dropdown-item elementor-widget-cmsmasters-nav-menu__item-active elementor-widget-cmsmasters-nav-menu__item-link-top"
                                aria-label="Menu item"
                              >
                                <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                  <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                    Home
                                  </span>
                                  <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                    <span className="cmsmasters-wrap-icon">
                                      <i className="fas fa-angle-down"></i>
                                    </span>
                                  </span>
                                </span>
                                <span className="cmsmasters-animation"></span>
                              </a>
                            </li>
                            <li
                              id="menu-item-7533"
                              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7533"
                            >
                              <a
                                href="/about/"
                                className="elementor-widget-cmsmasters-nav-menu__dropdown-item elementor-widget-cmsmasters-nav-menu__item-link-top"
                                aria-label="Menu item"
                              >
                                <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                  <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                  About
                                  </span>
                                  <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                    <span className="cmsmasters-wrap-icon">
                                      <i className="fas fa-angle-down"></i>
                                    </span>
                                  </span>
                                </span>
                                <span className="cmsmasters-animation"></span>
                              </a>
                            </li>
                            <li
                              id="menu-item-7546"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-7546"
                            >
                              <a
                                className="elementor-widget-cmsmasters-nav-menu__dropdown-item elementor-widget-cmsmasters-nav-menu__item-link-top"
                                aria-label="Menu item"
                              >
                                <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                  <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                    Services
                                  </span>
                                  <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                    <span className="cmsmasters-wrap-icon">
                                      <i className="fas fa-angle-down"></i>
                                    </span>
                                  </span>
                                </span>
                                <span className="cmsmasters-animation"></span>
                              </a>
                              <ul
                                className="sub-menu elementor-widget-cmsmasters-nav-menu__dropdown-submenu"
                                dropdown-align-right=""
                              >
                                <li
                                  id="menu-item-7535"
                                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7535"
                                >
                                  <a
                                    href="/buroojtrading"
                                    className="elementor-widget-cmsmasters-nav-menu__dropdown-item sub elementor-widget-cmsmasters-nav-menu__item-link-sub"
                                    aria-label="Menu item"
                                  >
                                    <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                      <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                        Burooj Trading
                                      </span>
                                      <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                        <span className="cmsmasters-wrap-icon">
                                          <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                        </span>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-animation"></span>
                                  </a>
                                </li>
                                <li
                                  id="menu-item-7536"
                                  className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-7536"
                                >
                                  <a
                                    href="/buroojinvestments"
                                    className="elementor-widget-cmsmasters-nav-menu__dropdown-item sub elementor-widget-cmsmasters-nav-menu__item-link-sub"
                                    aria-label="Menu item"
                                  >
                                    <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                      <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                        Burooj Investments
                                      </span>
                                      <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                        <span className="cmsmasters-wrap-icon">
                                          <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                        </span>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-animation"></span>
                                  </a>
                                </li>
                                <li
                                  id="menu-item-7544"
                                  className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-7544"
                                >
                                  <a
                                    href="/buroojproperties"
                                    className="elementor-widget-cmsmasters-nav-menu__dropdown-item sub elementor-widget-cmsmasters-nav-menu__item-link-sub"
                                    aria-label="Menu item"
                                  >
                                    <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                      <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                        Burooj Properties
                                      </span>
                                      <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                        <span className="cmsmasters-wrap-icon">
                                          <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                        </span>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-animation"></span>
                                  </a>
                                </li>
                                <li
                                  id="menu-item-7537"
                                  className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-7537"
                                >
                                  <a
                                    href="/buroojservices"
                                    className="elementor-widget-cmsmasters-nav-menu__dropdown-item sub elementor-widget-cmsmasters-nav-menu__item-link-sub"
                                    aria-label="Menu item"
                                  >
                                    <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                      <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                        Burooj Services
                                      </span>
                                      <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                        <span className="cmsmasters-wrap-icon">
                                          <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                        </span>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-animation"></span>
                                  </a>
                                </li>
                                {/* <li
                                  id="menu-item-9471"
                                  className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-9471"
                                >
                                  <a
                                    href="/cmsms_service/personal-loans/"
                                    className="elementor-widget-cmsmasters-nav-menu__dropdown-item sub elementor-widget-cmsmasters-nav-menu__item-link-sub"
                                    aria-label="Menu item"
                                  >
                                    <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                      <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                        Personal Loans
                                      </span>
                                      <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                        <span className="cmsmasters-wrap-icon">
                                          <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                        </span>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-animation"></span>
                                  </a>
                                </li> */}
                              </ul>
                            </li>
                            <li
                              id="menu-item-7534"
                              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7534"
                            >
                              <a
                                href="/new-insights/"
                                className="elementor-widget-cmsmasters-nav-menu__dropdown-item elementor-widget-cmsmasters-nav-menu__item-link-top"
                                aria-label="Menu item"
                              >
                                <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                  <span className="elementor-widget-cmsmasters-nav-menu__item-text">New & Insights</span>
                                  <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                    <span className="cmsmasters-wrap-icon">
                                      <i className="fas fa-angle-down"></i>
                                    </span>
                                  </span>
                                </span>
                                <span className="cmsmasters-animation"></span>
                              </a>
                            </li>
                            
                          </ul>
                        </nav>
                        <div className="elementor-widget-cmsmasters-nav-menu__toggle-container cmsmasters-layout-horizontal cmsmasters-menu-dropdown-type-">
                          <div className="elementor-widget-cmsmasters-nav-menu__toggle cmsmasters-icon-align-">
                            <span className="cmsmasters-toggle-icon">
                              <i className="fas fa-bars"></i>
                            </span>
                            <span className="cmsmasters-toggle-icon-active">
                              <i className="fas fa-times"></i>
                            </span>
                          </div>
                        </div>
                        <nav className="elementor-widget-cmsmasters-nav-menu__dropdown elementor-widget-cmsmasters-nav-menu__container cmsmasters-layout-horizontal cmsmasters-menu-dropdown-type-">
                          <ul
                            id="cmsmasters_menu-4-632bf7d7"
                            className="elementor-widget-cmsmasters-nav-menu__container-inner cmsmasters-nav-menu-dropdown ps"
                          >
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-7626 current_page_item menu-item-9259">
                              <a
                                href="/"
                                aria-current="page"
                                className="elementor-widget-cmsmasters-nav-menu__dropdown-item"
                                aria-label="Menu item"
                              >
                                <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                  <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                    Home
                                  </span>
                                  <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                    <span className="cmsmasters-wrap-icon">
                                      <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                    </span>
                                  </span>
                                </span>
                              </a>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7533">
                              <a
                                href="/blog/"
                                className="elementor-widget-cmsmasters-nav-menu__dropdown-item"
                                aria-label="Menu item"
                              >
                                <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                  <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                    Blog
                                  </span>
                                  <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                    <span className="cmsmasters-wrap-icon">
                                      <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                    </span>
                                  </span>
                                </span>
                              </a>
                            </li>
                            <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-7546">
                              <a
                                className="elementor-widget-cmsmasters-nav-menu__dropdown-item"
                                aria-label="Menu item"
                              >
                                <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                  <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                    Services
                                  </span>
                                  <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                    <span className="cmsmasters-wrap-icon">
                                      <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                    </span>
                                  </span>
                                </span>
                              </a>
                              <ul
                                className="sub-menu elementor-widget-cmsmasters-nav-menu__dropdown-submenu"
                                dropdown-align-right=""
                              >
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7535">
                                  <a
                                    href="/services/"
                                    className="elementor-widget-cmsmasters-nav-menu__dropdown-item sub"
                                    aria-label="Menu item"
                                  >
                                    <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                      <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                        Burooj Trading
                                      </span>
                                      <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                        <span className="cmsmasters-wrap-icon">
                                          <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                        </span>
                                      </span>
                                    </span>
                                  </a>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-7536">
                                  <a
                                    href="/cmsms_service/checking-accounts/"
                                    className="elementor-widget-cmsmasters-nav-menu__dropdown-item sub"
                                    aria-label="Menu item"
                                  >
                                    <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                      <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                        Burooj Investments
                                      </span>
                                      <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                        <span className="cmsmasters-wrap-icon">
                                          <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                        </span>
                                      </span>
                                    </span>
                                  </a>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-7544">
                                  <a
                                    href="/cmsms_service/wealth-management/"
                                    className="elementor-widget-cmsmasters-nav-menu__dropdown-item sub"
                                    aria-label="Menu item"
                                  >
                                    <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                      <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                        Wealth Management
                                      </span>
                                      <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                        <span className="cmsmasters-wrap-icon">
                                          <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                        </span>
                                      </span>
                                    </span>
                                  </a>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-7537">
                                  <a
                                    href="/cmsms_service/credit-cards/"
                                    className="elementor-widget-cmsmasters-nav-menu__dropdown-item sub"
                                    aria-label="Menu item"
                                  >
                                    <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                      <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                        Credit Cards
                                      </span>
                                      <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                        <span className="cmsmasters-wrap-icon">
                                          <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                        </span>
                                      </span>
                                    </span>
                                  </a>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-9471">
                                  <a
                                    href="/cmsms_service/personal-loans/"
                                    className="elementor-widget-cmsmasters-nav-menu__dropdown-item sub"
                                    aria-label="Menu item"
                                  >
                                    <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                      <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                        Personal Loans
                                      </span>
                                      <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                        <span className="cmsmasters-wrap-icon">
                                          <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                        </span>
                                      </span>
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7534">
                              <a
                                href="/contacts/"
                                className="elementor-widget-cmsmasters-nav-menu__dropdown-item"
                                aria-label="Menu item"
                              >
                                <span className="elementor-widget-cmsmasters-nav-menu__item-text-wrap">
                                  <span className="elementor-widget-cmsmasters-nav-menu__item-text">
                                    Contacts
                                  </span>
                                  <span className="elementor-widget-cmsmasters-nav-menu__arrow">
                                    <span className="cmsmasters-wrap-icon">
                                      <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-down"></i>
                                    </span>
                                  </span>
                                </span>
                              </a>
                            </li>
                            <div
                              className="ps__rail-x"
                              style={{ left: "0px", bottom: "0px" }}
                            >
                              <div
                                className="ps__thumb-x"
                                
                                style={{ left: "0px", width: "0px" }}
                              ></div>
                            </div>
                            <div
                              className="ps__rail-y"
                              style={{ top: "0px", right: "0px" }}
                            >
                              <div
                                className="ps__thumb-y"
                                
                                style={{ top: "0px", height: "0px" }}
                              ></div>
                            </div>
                          </ul>
                        </nav>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-31f891aa"
                  data-id="31f891aa"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-7c561dc1 cmsmasters-search-type-search-popup cmsmasters-popup-trigger-type-link elementor-widget__width-initial cmsmasters-popup-trigger-content-icon cmsmasters-popup-close-view-default cmsmasters-popup-close-icon-position-right cmsmasters-submit-button-view-button cmsmasters-form-input-icon-no cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-search"
                      data-id="7c561dc1"
                      data-element_type="widget"
                      data-settings='{"type_of_search":"search-popup","esc_close":"yes"}'
                      data-widget_type="cmsmasters-search.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-widget-cmsmasters-search__container">
                          <div className="elementor-widget-cmsmasters-search__popup-container cmsmasters-search-popup-move-up-effect cmsmasters-overlay-close cmsmasters-disabled-scroll">
                            <div className="elementor-widget-cmsmasters-search__popup-content">
                              <form
                                role="search"
                                method="get"
                                className="elementor-widget-cmsmasters-search__form "
                                action="/"
                              >
                                <div className="elementor-widget-cmsmasters-search__form-container cmsmasters-submit-button-view-button cmsmasters-buttons-type-icon">
                                  <input
                                    type="search"
                                    className="elementor-widget-cmsmasters-search__field "
                                   
                                    name="s"
                                    placeholder="Search..."
                                  />
                                  <button
                                    type="submit"
                                    className="elementor-widget-cmsmasters-search__submit"
                                  >
                                    <span className="elementor-widget-cmsmasters-search__submit-icon">
                                      <i className="cmsmsdemo-icon- cmsms-demo-icon-search1"></i>
                                    </span>
                                  </button>
                                </div>
                              </form>
                            </div>
                            <span className="elementor-widget-cmsmasters-search__popup-close">
                              <span className="elementor-widget-cmsmasters-search__popup-close-icon">
                                <i className="cmsmsdemo-icon- cmsms-demo-icon-close"></i>
                              </span>
                            </span>
                          </div>
                          <div className="elementor-widget-cmsmasters-search__popup-trigger-container">
                            <div className="elementor-widget-cmsmasters-search__popup-trigger-inner">
                              <span className="elementor-widget-cmsmasters-search__popup-trigger-inner-icon">
                                <i className="cmsmsdemo-icon- cmsms-demo-icon-search1"></i>
                              </span>
                            </div>
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-455244cf elementor-widget__width-initial cmsmasters-button-mobile-align-justify elementor-widget-tablet__width-initial elementor-hidden-mobile cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                      data-id="455244cf"
                      data-element_type="widget"
                      data-widget_type="cmsmasters-button.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-widget-cmsmasters-button__button-container">
                          <div className="elementor-widget-cmsmasters-button__button-container-inner">
                            <a
                              href="/contacts/"
                              className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                              role="button"
                              style={{border:"1.5px solid #2a2a2a"}}
                            >
                              <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-left">
                                <span className="elementor-widget-cmsmasters-button__icon">
                                  <i
                                    aria-hidden="true"
                                    className="cmsmsdemo-icon- cmsms-demo-icon-log-in"
                                  ></i>
                                </span>
                                <span className="elementor-widget-cmsmasters-button__text">
                                  Contact Us
                                </span>
                              </span>
                            </a>
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-8408496 elementor-widget__width-initial cmsmasters-trigger-view-framed elementor-hidden-desktop elementor-widget-tablet__width-initial cmsmasters-trigger-border-type-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-offcanvas"
                      data-id="8408496"
                      data-element_type="widget"
                      data-settings='{"content_block":[{"_id":"61e5ee6","nav_menu":null,"offcanvas_item_style":"yes","offcanvas_padding":{"unit":"px","top":"0","right":"20","bottom":"0","left":"20","isLinked":false},"offcanvas_padding_mobile":{"unit":"px","top":"0","right":"15","bottom":"0","left":"15","isLinked":false},"logo_image":null,"logo_type":null,"description":null,"title":"","content_type":"logo","logo_image_source":"default","logo_image_retina":null,"logo_image_2x":null,"logo_image_second_toggle":null,"logo_image_second":null,"logo_image_2x_second":null,"logo_title":null,"logo_link":"home","logo_custom_url":null,"sidebar":null,"saved_section":null,"template_id":null,"content_custom_bg":"","box_to_down":"false"},{"_id":"aa42cf9","content_type":"navigation","nav_menu":"80","offcanvas_item_style":"yes","offcanvas_padding":{"unit":"px","top":"0","right":"20","bottom":"0","left":"20","isLinked":false},"offcanvas_padding_mobile":{"unit":"px","top":"0","right":"15","bottom":"0","left":"15","isLinked":false},"description":null,"title":"","logo_image_source":null,"logo_type":null,"logo_image":null,"logo_image_retina":null,"logo_image_2x":null,"logo_image_second_toggle":null,"logo_image_second":null,"logo_image_2x_second":null,"logo_title":null,"logo_link":null,"logo_custom_url":null,"sidebar":null,"saved_section":null,"template_id":null,"content_custom_bg":"","box_to_down":"false"},{"content_type":"section","nav_menu":null,"offcanvas_item_style":"yes","offcanvas_padding":{"unit":"px","top":"0","right":"20","bottom":"0","left":"20","isLinked":false},"offcanvas_padding_mobile":{"unit":"px","top":"0","right":"15","bottom":"0","left":"15","isLinked":false},"_id":"7e275af","saved_section":"9595","content_margin_bottom":{"unit":"px","size":50,"sizes":[]},"description":null,"title":"","logo_image_source":null,"logo_type":null,"logo_image":null,"logo_image_retina":null,"logo_image_2x":null,"logo_image_second_toggle":null,"logo_image_second":null,"logo_image_2x_second":null,"logo_title":null,"logo_link":null,"logo_custom_url":null,"sidebar":null,"template_id":null,"content_custom_bg":"","box_to_down":"false"},{"_id":"a061751","content_type":"section","nav_menu":null,"saved_section":"9598","box_to_down":"true","description":null,"title":"","logo_image_source":null,"logo_type":null,"logo_image":null,"logo_image_retina":null,"logo_image_2x":null,"logo_image_second_toggle":null,"logo_image_second":null,"logo_image_2x_second":null,"logo_title":null,"logo_link":null,"logo_custom_url":null,"sidebar":null,"template_id":null,"offcanvas_item_style":"","content_custom_bg":null}],"canvas_position":"left","animation_type":"slide","overlay_close":"yes","esc_close":"yes"}'
                      data-widget_type="cmsmasters-offcanvas.default"
                    >
                      <div
                        className="elementor-widget-container"
                        onClick={handleToggle}
                      >
                        <div className="elementor-widget-cmsmasters-offcanvas__wrapper">
                          <div className="elementor-widget-cmsmasters-offcanvas__trigger-container">
                            <div className="elementor-widget-cmsmasters-offcanvas__trigger">
                              <span className="elementor-widget-cmsmasters-offcanvas__trigger-icon">
                                <i
                                  className={`cmsmsdemo-icon- cmsms-demo-icon-menu ${
                                    istoggle ? "trigger-active" : ""
                                  }`}
                                ></i>
                              </span>
                              <span className="elementor-widget-cmsmasters-offcanvas__trigger-icon-active">
                                <i className="fas fa-times"></i>
                              </span>
                            </div>
                          </div>
                          <div
                            className={` ${
                              istoggle ? "active" : ""
                            } elementor-widget-cmsmasters-offcanvas__content cmsmasters-offcanvas-content-8408496 cmsmasters-canvas-animation-type-slide cmsmasters-canvas-position-left cmsmasters-offcanvas-alignment-center`}
                          >
                            <div className="elementor-widget-cmsmasters-offcanvas__close-container cmsmasters-close-hor-align- cmsmasters-close-ver-align- cmsmasters-position-inside cmsmasters-close-view-default">
                              <div className="elementor-widget-cmsmasters-offcanvas__close">
                                <span className="elementor-widget-cmsmasters-offcanvas__close-icon">
                                  <i className="cmsmsdemo-icon- cmsms-demo-icon-close"></i>
                                </span>
                              </div>
                            </div>
                            <div className="elementor-widget-cmsmasters-offcanvas__body">
                              <div className="elementor-widget-cmsmasters-offcanvas__body-container cmsmasters-block-all-down">
                                <div className="elementor-widget-cmsmasters-offcanvas__custom-container elementor-repeater-item-61e5ee6 cmsmasters-box-down-false">
                                  <div className="elementor-widget-cmsmasters-offcanvas__custom-container-cont">
                                    <div className="elementor-widget-cmsmasters-offcanvas__custom-container-cont-inner">
                                      <div className="elementor-widget-cmsmasters-offcanvas__site-logo">
                                        <a
                                          href="/"
                                          className="elementor-widget-cmsmasters-offcanvas__site-logo-link"
                                        >
                                          <img
                                            src="/imges/burooj/logo.png"
                                            width={"80px"}
                                            height={"20px"}
                                            style={{width:"127px"}}
                                            alt="burooj"
                                            title="Classic"
                                            className="elementor-widget-cmsmasters-offcanvas__site-logo-img elementor-widget-cmsmasters-offcanvas__site-logo-main"
                                          />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="elementor-widget-cmsmasters-offcanvas__custom-container elementor-repeater-item-aa42cf9 cmsmasters-box-down-false">
                                  <div className="elementor-widget-cmsmasters-offcanvas__custom-container-cont">
                                    <div className="elementor-widget-cmsmasters-offcanvas__custom-container-cont-inner">
                                      <nav className="elementor-widget-cmsmasters-offcanvas__menu-container">
                                        <ul
                                          id="menu-1-8408496"
                                          className="elementor-widget-cmsmasters-offcanvas__menu-inner"
                                        >
                                          <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-7626 current_page_item menu-item-9259">
                                            <a
                                              href="/"
                                              aria-current="page"
                                              className=" elementor-widget-cmsmasters-offcanvas__item-active elementor-widget-cmsmasters-offcanvas__item elementor-widget-cmsmasters-offcanvas__main-item"
                                              aria-label="Menu item"
                                            >
                                              <span className="elementor-widget-cmsmasters-offcanvas__item-text">
                                                Home
                                              </span>
                                            </a>
                                          </li>
                                          <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7533">
                                            <a
                                              href="/about/"
                                              className=" elementor-widget-cmsmasters-offcanvas__item elementor-widget-cmsmasters-offcanvas__main-item"
                                              aria-label="Menu item"
                                            >
                                              <span className="elementor-widget-cmsmasters-offcanvas__item-text">
                                                About
                                              </span>
                                            </a>
                                          </li>
                                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-7546">
                                            <a
                                              className=" elementor-widget-cmsmasters-offcanvas__item elementor-widget-cmsmasters-offcanvas__main-item"
                                              aria-label="Menu item"
                                              type="button"
                                              onClick={handledisplay}
                                            >
                                              <span className="elementor-widget-cmsmasters-offcanvas__item-text">
                                                Services
                                              </span>
                                            </a>
                                            <ul className="sub-menu" style={{display:isdisplay&&"block"}}>
                                              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7535">
                                                <a
                                                  href="/buroojtrading"
                                                  className=" elementor-widget-cmsmasters-offcanvas__item elementor-widget-cmsmasters-offcanvas__submenu-item"
                                                  aria-label="Menu item"
                                                >
                                                  <span className="elementor-widget-cmsmasters-offcanvas__item-text">
                                                    Burooj Trading
                                                  </span>
                                                </a>
                                              </li>
                                              <li className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-7536">
                                                <a
                                                  href="/buroojinvestments"
                                                  className=" elementor-widget-cmsmasters-offcanvas__item elementor-widget-cmsmasters-offcanvas__submenu-item"
                                                  aria-label="Menu item"
                                                >
                                                  <span className="elementor-widget-cmsmasters-offcanvas__item-text">
                                                    Burooj Investments
                                                  </span>
                                                </a>
                                              </li>
                                              <li className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-7544">
                                                <a
                                                  href="/buroojproperties"
                                                  className=" elementor-widget-cmsmasters-offcanvas__item elementor-widget-cmsmasters-offcanvas__submenu-item"
                                                  aria-label="Menu item"
                                                >
                                                  <span className="elementor-widget-cmsmasters-offcanvas__item-text">
                                                  Burooj Properties
                                                  </span>
                                                </a>
                                              </li>
                                              <li className="menu-item menu-item-type-post_type menu-item-object-cmsms_service menu-item-7537">
                                                <a
                                                  href="/buroojservices"
                                                  className=" elementor-widget-cmsmasters-offcanvas__item elementor-widget-cmsmasters-offcanvas__submenu-item"
                                                  aria-label="Menu item"
                                                >
                                                  <span className="elementor-widget-cmsmasters-offcanvas__item-text">
                                                  Burooj Services
                                                  </span>
                                                </a>
                                              </li>
                                           
                                            </ul>
                                          </li>
                                          <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7534">
                                            <a
                                              href="/contacts/"
                                              className=" elementor-widget-cmsmasters-offcanvas__item elementor-widget-cmsmasters-offcanvas__main-item"
                                              aria-label="Menu item"
                                              style={{border:"1.5px solid #2a2a2a"}}
                                            >
                                              <span className="elementor-widget-cmsmasters-offcanvas__item-text">
                                                Contact Us
                                              </span>
                                            </a>
                                          </li>
                                        </ul>
                                      </nav>
                                    </div>
                                  </div>
                                </div>
                                <div className="elementor-widget-cmsmasters-offcanvas__custom-container elementor-repeater-item-7e275af cmsmasters-box-down-false">
                                  <div className="elementor-widget-cmsmasters-offcanvas__custom-container-cont">
                                    <div className="elementor-widget-cmsmasters-offcanvas__custom-container-cont-inner">
                                      <div
                                        data-elementor-type="section"
                                        data-elementor-id="9595"
                                        className="elementor elementor-9595 cmsmasters-location-cmsmasters_header cmsmasters-header-position-absolute-"
                                      >
                                        {" "}
                                        <div className="elementor-inner">
                                          <div className="elementor-section-wrap">
                                            <section
                                              className="elementor-section elementor-top-section elementor-element elementor-element-047345a elementor-hidden-desktop elementor-hidden-tablet elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                              data-id="047345a"
                                              data-element_type="section"
                                            >
                                              <div className="elementor-container elementor-column-gap-no">
                                                <div
                                                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c2103d3"
                                                  data-id="c2103d3"
                                                  data-element_type="column"
                                                >
                                                  <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                      className="elementor-element elementor-element-6c2f955 cmsmasters-widget-align-center cmsmasters-widget-layout-row cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                                                      data-id="6c2f955"
                                                      data-element_type="widget"
                                                      data-widget_type="cmsmasters-icon-list.default"
                                                    >
                                                      <div className="elementor-widget-container">
                                                        <ul className="cmsmasters-widget-icon-list-items">
                                                          <li className="cmsmasters-widget-icon-list-item">
                                                            <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                              <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                                                <span className="cmsmasters-widget-icon-list-item-text">
                                                                  <a href="#">
                                                                  
                                                                  </a>{" "}
                                                                </span>
                                                              </span>
                                                            </span>
                                                          </li>
                                                          <li className="cmsmasters-widget-icon-list-item">
                                                            <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                              <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                                                <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                                                  <a href="#">
                                                              
                                                                  </a>{" "}
                                                                </span>
                                                              </span>
                                                            </span>
                                                          </li>
                                                          <li className="cmsmasters-widget-icon-list-item">
                                                            <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                              <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                                                <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                                                  <a href="#">
                                                                 
                                                                  </a>{" "}
                                                                </span>
                                                              </span>
                                                            </span>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </section>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="elementor-widget-cmsmasters-offcanvas__custom-container elementor-repeater-item-a061751 cmsmasters-box-down-true">
                                  <div className="elementor-widget-cmsmasters-offcanvas__custom-container-cont">
                                    <div className="elementor-widget-cmsmasters-offcanvas__custom-container-cont-inner">
                                      <div
                                        data-elementor-type="section"
                                        data-elementor-id="9598"
                                        className="elementor elementor-9598 cmsmasters-location-cmsmasters_header cmsmasters-header-position-absolute-"
                                      >
                                        {" "}
                                        <div className="elementor-inner">
                                          <div className="elementor-section-wrap">
                                            <section
                                              className="elementor-section elementor-top-section elementor-element elementor-element-ac385a6 elementor-hidden-desktop elementor-hidden-tablet elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                              data-id="ac385a6"
                                              data-element_type="section"
                                            >
                                              <div className="elementor-container elementor-column-gap-no">
                                                <div
                                                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4269a0d"
                                                  data-id="4269a0d"
                                                  data-element_type="column"
                                                >
                                                  <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                      className="elementor-element elementor-element-f2171df cmsmasters-button-align-center cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                                                      data-id="f2171df"
                                                      data-element_type="widget"
                                                      data-widget_type="cmsmasters-button.default"
                                                    >
                                                      <div className="elementor-widget-container">
                                                        <div className="elementor-widget-cmsmasters-button__button-container">
                                                          <div className="elementor-widget-cmsmasters-button__button-container-inner">
                                                            <a
                                                              href="/"
                                                              className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                                              role="button"
                                                            >
                                                              <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-left">
                                                                <span className="elementor-widget-cmsmasters-button__icon">
                                                                  {/* <i aria-hidden="true" className="cmsmsdemo-icon- cmsms-demo-icon-card"></i> */}
                                                                </span>
                                                                <span className="elementor-widget-cmsmasters-button__text"></span>
                                                              </span>
                                                            </a>
                                                          </div>
                                                        </div>{" "}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </section>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="elementor-widget-cmsmasters-offcanvas__container__overlay"></div>
                        </div>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-62edf0d6 elementor-section-content-middle elementor-hidden-desktop elementor-hidden-tablet elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
              data-id="62edf0d6"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-wide">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-248b2451"
                  data-id="248b2451"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-22b283e9 cmsmasters-button-tablet-align-justify cmsmasters-button-mobile-align-justify cmsmasters-button-align-justify cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                      data-id="22b283e9"
                      data-element_type="widget"
                      data-widget_type="cmsmasters-button.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-widget-cmsmasters-button__button-container">
                          <div className="elementor-widget-cmsmasters-button__button-container-inner cmsmasters-with-percentage">
                            <a
                              href="/contacts/"
                              className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                              role="button"
                              style={{border:"2px solid #191B22"}}
                            >
                              <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-left">
                                <span className="elementor-widget-cmsmasters-button__icon">
                                  <i
                                    aria-hidden="true"
                                    className="cmsmsdemo-icon- cmsms-demo-icon-log-in"
                                  ></i>
                                </span>
                                <span className="elementor-widget-cmsmasters-button__text">
                                 Contact Us
                                </span>
                              </span>
                            </a>
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
